import { CartContext } from './cart-store'
import { NavbarContext } from './navbar-store'

const ContextStores = {
  navbar: NavbarContext,
  cart: CartContext,
}

export { ContextStores }
